export function createScheduleVisitSession() {
    let generation = 0;

    return {
        begin() {
            generation += 1;

            return generation;
        },

        invalidate() {
            generation += 1;
        },

        isCurrent(session) {
            return generation === session;
        },
    };
}

export function resetConfirmationOnDrawerClose(state, target = globalThis) {
    target.addEventListener('schedule-visit-closed', () => {
        state.confirmingSlot = false;
    });
}
